import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';
import { Observable, of, Subject, throwError } from 'rxjs';
import {
  catchError,
  map,
  shareReplay,
  switchMap,
  take,
  tap,
} from 'rxjs/operators';
import { SessionRefresh } from '../../models/session_refresh';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private refreshTokenSubject: Subject<string> | null = null;
  private refreshTokenInProgress = false;

  constructor(
    private http: HttpClient,
    private cookieServices: CookieService
  ) {}

  saveAccessToken(accessToken: string) {
    this.cookieServices.set(
      'accessToken',
      accessToken,
      0,
      '/',
      environment.domainCookie,
      true,
      'Lax'
    );
  }

  refreshToken(): Observable<void> {
    if (this.refreshTokenInProgress)
      return this.refreshTokenSubject!.pipe(
        take(1),
        switchMap(() => of(void 0))
      );

    this.refreshTokenInProgress = true;
    this.refreshTokenSubject = new Subject<string>();

    const currentRefreshTokenValue = this.cookieServices.get('refreshToken');

    return this.http
      .get<SessionRefresh>(
        `${environment.urlApiSSO}/api/v1/autenticacion/refrescartoken?token=${currentRefreshTokenValue}`
      )
      .pipe(
        tap((data) => {
          if (data?.accessToken) {
            this.saveAccessToken(data.accessToken);
            this.refreshTokenSubject!.next(data.accessToken);
          }
        }),
        catchError((error) => {
          this.refreshTokenSubject!.error(error);
          return throwError(() => error);
        }),
        map(() => void 0),
        shareReplay(1),
        tap({
          finalize: () => {
            this.refreshTokenInProgress = false;
            this.refreshTokenSubject = null;
          },
        })
      );
  }
}
